<script setup lang="ts">
export type BreadcrumbItem = {
  label: string;
  to?: string;
};

type Props = {
  items: BreadcrumbItem[];
  separator?: string;
};

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  separator: "/",
});
</script>

<template>
  <nav
    aria-label="breadcrumb"
    class="ml-2 flex items-center space-x-2 py-2 text-sm"
  >
    <ol class="flex flex-wrap items-center space-x-2">
      <li
        v-for="(item, idx) in props.items"
        :key="`${idx}-${item.label}`"
        class="flex items-center mr-1"
      >
        <template v-if="idx > 0">
          <span class="text-slate-300 mr-1" aria-hidden="true"
            >&gt;</span
          >
        </template>

        <RouterLink
          v-if="item.to"
          :to="item.to"
          class="text-slate-600 hover:text-blue-600 font-medium transition-colors"
        >
          {{ item.label }}
        </RouterLink>
        <span v-else class="text-slate-900 font-bold">
          {{ item.label }}
          </span>
      </li>
    </ol>
  </nav>
</template>

